@if (showModal()) {
  <div class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[1500] p-4"
       (click)="dismiss()">
    <div
        class="bg-dark-gray rounded-2xl border border-white/10 shadow-glow max-w-md w-full animate-appear overflow-hidden relative"
        (click)="$event.stopPropagation()">

      <!-- Close button -->
      <button (click)="dismiss()"
              aria-label="Close"
              class="absolute top-4 right-4 text-white/50 hover:text-white transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>

      <div class="p-8 flex flex-col items-center">
        @if (showThankYou()) {
          <!-- Thank you state -->
          <div class="text-electric-blue mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-white">Thanks!</h2>
          <p class="text-white/60 mt-2">We'll keep you posted.</p>
        } @else {
          <!-- Form state -->
          <h2 class="text-3xl font-bold text-white mb-3">Enjoy your results?</h2>
          <p class="text-white/60 text-center mb-6">
            We share how to improve results, what's coming next, and real use cases.
          </p>
          <form (ngSubmit)="submit()" class="w-full flex flex-col gap-4">
            <div class="w-full">
              <input
                  type="email"
                  [(ngModel)]="email"
                  name="email"
                  placeholder="Your email"
                  required
                  (input)="onEmailInput()"
                  class="w-full px-4 py-3 rounded-lg bg-white/5 border text-white placeholder-white/40
                         focus:outline-none focus:border-electric-blue/50 focus:ring-1 focus:ring-electric-blue/30
                         transition-colors"
                  [ngClass]="showError() ? 'border-red-500' : 'border-white/10'"/>
              @if (showError()) {
                <p class="text-red-400 text-sm mt-1.5">Please enter a valid email address.</p>
              }
            </div>
            <button
                type="submit"
                class="w-full py-3 rounded-lg font-semibold text-white
                       bg-gradient-to-r from-electric-blue to-magenta
                       hover:shadow-glow-sm hover:-translate-y-0.5
                       transition-all">
              Keep me posted
            </button>
          </form>
        }
      </div>
    </div>
  </div>
}
